export const getFilteredData = (data, tab) => {
  let filteredTableData = [...data];
  if (tab === "main") {
    filteredTableData =
      data && data.filter((row) => row.subAccountName === "Main");
  } else if (tab === "sub") {
    filteredTableData =
      data && data.filter((row) => row.subAccountName !== "Main");
  }
  return filteredTableData;
};
